export default "__VITE_ASSET__6h5xQP8i__"